

// // import React, { useState, useEffect } from 'react';
// // import { Modal, Button, Badge, Form, Alert, Spinner, Table, Pagination } from "react-bootstrap";
// // import axios from "axios";
// // import config from '../../Common/Configurations/APIConfig';
// // import DefaultData from '../../Common/CompanyData/DefaultData';

// // const Appointments = () => {
// //     // ================= DATA STATES =================
// //     const [allAppointments, setAllAppointments] = useState([]); 
// //     const [filteredAppointments, setFilteredAppointments] = useState([]); 
// //     const [salons, setSalons] = useState([]);
// //     const [staffList, setStaffList] = useState([]);
// //     const [services, setServices] = useState([]);
    
// //     // ================= UI STATES =================
// //     const [loading, setLoading] = useState(true);
// //     const [btnLoading, setBtnLoading] = useState(false);
// //     const [error, setError] = useState('');
// //     const [success, setSuccess] = useState('');

// //     // ================= PAGINATION STATES =================
// //     const [currentPage, setCurrentPage] = useState(1);
// //     const [itemsPerPage] = useState(10); 

// //     // ================= FILTER STATES =================
// //     const [filters, setFilters] = useState({
// //         searchTerm: '',
// //         appointmentNo: '',
// //         status: 'all',
// //         salonId: 'all',
// //         date: ''
// //     });

// //     // ================= MODAL STATES =================
// //     const [showDetailsModal, setShowDetailsModal] = useState(false);
// //     const [selectedAppointment, setSelectedAppointment] = useState(null);
    
// //     const [showCancelModal, setShowCancelModal] = useState(false);
// //     const [appointmentToCancel, setAppointmentToCancel] = useState(null);

// //     const [showFormModal, setShowFormModal] = useState(false);
// //     const [isEditMode, setIsEditMode] = useState(false);
    
// //     // Form State (For Create/Edit)
// //     const initialFormState = {
// //         appointmentId: null,
// //         salonId: '',
// //         customerName: '',
// //         email: '',
// //         phoneNumber: '',
// //         serviceTypeId: '',
// //         staffId: '',
// //         startTime: '',
// //         endTime: '',
// //         status: 'PENDING',
// //         notes: ''
// //     };
// //     const [formData, setFormData] = useState(initialFormState);
// //     const [filteredStaff, setFilteredStaff] = useState([]); 

// //     // ================= CONSTANTS =================
// //     const THEME_COLOR = '#065f46';
// //     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';
// //     const STATUS_COLORS = {
// //         'Scheduled': 'primary', 'Confirmed': 'success', 'CONFIRMED': 'success',
// //         'Completed': 'secondary', 'COMPLETED': 'secondary', 'Cancelled': 'danger',
// //         'CANCELLED': 'danger', 'Pending': 'warning', 'PENDING': 'warning', 'Noshow': 'dark'
// //     };

// //     // ================= INITIAL LOAD =================
// //     useEffect(() => {
// //         fetchDropdowns();
// //         fetchAppointments();
// //     }, []);

// //     useEffect(() => {
// //         applyFilters();
// //         setCurrentPage(1);
// //     }, [filters, allAppointments]);

// //     // ================= API CALLS =================
// //     const fetchDropdowns = async () => {
// //         try {
// //             const [salonRes, staffRes, serviceRes] = await Promise.all([
// //                 axios.get(`${config.APIACTIVEURL}${config.GETALLSALON}`),
// //                 axios.get(`${config.APIACTIVEURL}${config.GETALLSTAFF}`),
// //                 axios.get(`${config.APIACTIVEURL}${config.GETSERVICETYPE}`)
// //             ]);
// //             setSalons(salonRes.data.data || salonRes.data || []);
// //             setStaffList(staffRes.data.data || staffRes.data || []);
// //             setServices(serviceRes.data.data || serviceRes.data || []);
// //         } catch (err) {
// //             console.error("Error loading dropdowns", err);
// //         }
// //     };

// //     const fetchAppointments = async () => {
// //         try {
// //             setLoading(true);
// //             setError('');
// //             const res = await axios.get(`${config.APIACTIVEURL}${config.GETALLAPPOINTMENTS}`, {
// //                 params: { pageSize: 1000, pageNumber: 1 } 
// //             });
            
// //             let data = [];
// //             if (res.data.data && Array.isArray(res.data.data)) { data = res.data.data; }
// //             else if (Array.isArray(res.data)) { data = res.data; }
// //             else if (res.data.items) { data = res.data.items; }

// //             setAllAppointments(data);
// //             setFilteredAppointments(data); 
// //         } catch (error) {
// //             setError('Failed to load appointments.');
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     // ================= FILTER LOGIC =================
// //     const applyFilters = () => {
// //         let result = [...allAppointments];

// //         if (filters.appointmentNo) {
// //             const term = filters.appointmentNo.toLowerCase();
// //             result = result.filter(item => (item.appointmentNo || '').toLowerCase().includes(term));
// //         }
// //         if (filters.salonId !== 'all') {
// //             result = result.filter(item => item.salonId === filters.salonId);
// //         }
// //         if (filters.status !== 'all') {
// //             result = result.filter(item => (item.status || '').toUpperCase() === filters.status.toUpperCase());
// //         }
// //         if (filters.date) {
// //             result = result.filter(item => item.startTime && item.startTime.startsWith(filters.date));
// //         }
// //         if (filters.searchTerm) {
// //             const term = filters.searchTerm.toLowerCase();
// //             result = result.filter(item => 
// //                 (item.user?.name || item.customerName || '').toLowerCase().includes(term) ||
// //                 (item.user?.email || item.email || '').toLowerCase().includes(term) ||
// //                 (item.user?.phoneNumber || item.phoneNumber || '').toLowerCase().includes(term)
// //             );
// //         }
// //         setFilteredAppointments(result);
// //     };

// //     const clearFilters = () => {
// //         setFilters({ searchTerm: '', appointmentNo: '', status: 'all', salonId: 'all', date: '' });
// //     };

// //     const indexOfLastItem = currentPage * itemsPerPage;
// //     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
// //     const currentTableData = filteredAppointments.slice(indexOfFirstItem, indexOfLastItem);
// //     const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage);

// //     useEffect(() => {
// //         if (formData.salonId) {
// //             const salonStaff = staffList.filter(s => s.salonId === formData.salonId);
// //             setFilteredStaff(salonStaff);
// //         } else {
// //             setFilteredStaff([]);
// //         }
// //     }, [formData.salonId, staffList]);

// //     const handleFormSubmit = async () => {
// //         if (!formData.customerName || !formData.email || !formData.salonId || !formData.startTime || !formData.serviceTypeId) {
// //             setError("Please fill in all required fields.");
// //             return;
// //         }

// //         setBtnLoading(true);
// //         setError('');
        
// //         try {
// //             const payload = {
// //                 appointmentId: isEditMode ? formData.appointmentId : "00000000-0000-0000-0000-000000000000",
// //                 salonId: formData.salonId,
// //                 serviceTypeId: formData.serviceTypeId,
// //                 staffId: formData.staffId || "00000000-0000-0000-0000-000000000000",
// //                 customerName: formData.customerName,
// //                 email: formData.email,
// //                 phoneNumber: formData.phoneNumber || "",
// //                 startTime: formData.startTime,
// //                 endTime: formData.endTime || formData.startTime, 
// //                 status: formData.status || "PENDING",
// //                 notes: formData.notes || ""
// //             };

// //             const baseUrl = `${config.APIACTIVEURL}${config.APPOINTMENTS}`; 

// //             if (isEditMode) {
// //                 await axios.put(`${baseUrl}/${payload.appointmentId}`, payload);
// //                 setSuccess('Appointment updated successfully!');
// //             } else {
// //                 await axios.post(baseUrl, payload);
// //                 setSuccess('Appointment created successfully!');
// //             }

// //             setShowFormModal(false);
// //             fetchAppointments(); 
// //             setTimeout(() => setSuccess(''), 3000);
// //         } catch (err) {
// //             setError(err.response?.data?.message || 'Operation failed.');
// //         } finally {
// //             setBtnLoading(false);
// //         }
// //     };

// //     const openCreateModal = () => {
// //         setFormData(initialFormState);
// //         setIsEditMode(false);
// //         setShowFormModal(true);
// //     };

// //     const openEditModal = (apt) => {
// //         setFormData({
// //             appointmentId: apt.appointmentId,
// //             salonId: apt.salonId || '',
// //             customerName: apt.user?.name || apt.customerName || '',
// //             email: apt.user?.email || apt.email || '',
// //             phoneNumber: apt.user?.phoneNumber || apt.phoneNumber || '',
// //             serviceTypeId: apt.serviceTypeId || '',
// //             staffId: (apt.staffId === "00000000-0000-0000-0000-000000000000" || !apt.staffId) ? '' : apt.staffId,
// //             startTime: apt.startTime ? apt.startTime.slice(0, 16) : '',
// //             endTime: apt.endTime ? apt.endTime.slice(0, 16) : '',
// //             status: apt.status || 'PENDING',
// //             notes: apt.notes || ''
// //         });
// //         setIsEditMode(true);
// //         setShowFormModal(true);
// //     };

// //     const handleCancel = async () => {
// //         if (!appointmentToCancel) return;
// //         setBtnLoading(true);
// //         try {
// //             if (appointmentToCancel.appointmentNo) {
// //                 await axios.post(`${config.APIACTIVEURL}${config.CANCELAPPPOINTMENT}/${appointmentToCancel.appointmentNo}`);
// //             } else {
// //                  await axios.delete(`${config.APIACTIVEURL}${config.APPOINTMENTS}/${appointmentToCancel.appointmentId}`);
// //             }
// //             fetchAppointments();
// //             setSuccess('Appointment cancelled.');
// //             setShowCancelModal(false);
// //             setTimeout(() => setSuccess(''), 3000);
// //         } catch (err) {
// //             setError(err.response?.data?.message || 'Failed to cancel.');
// //         } finally {
// //             setBtnLoading(false);
// //         }
// //     };

// //     const formatDateTime = (dateString) => {
// //         if (!dateString) return 'N/A';
// //         const cleanDate = dateString.replace('Z', '').split('.')[0];
// //         const d = new Date(cleanDate); 
// //         return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
// //     };

// //     const formatCurrency = (amount) => `${currency} ${amount?.toFixed(2) || '0.00'}`;

// //     return (
// //         <div className="page-content" style={{ paddingTop: "90px", minHeight: '100vh', backgroundColor: '#f8fafc' }}>
// //             <div className="container-fluid px-lg-4">
                
// //                 {/* --- HEADER --- */}
// //                 <div className="card border-0 shadow-sm rounded-4 mb-4">
// //                     <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
// //                         <h4 className="fw-bold mb-0" style={{ color: THEME_COLOR }}>
// //                             <i className="ri-admin-line me-2"></i>
// //                             Appointments (Admin)
// //                         </h4>
// //                         <div className="d-flex gap-2">
// //                             <Button variant="danger" size="sm" onClick={clearFilters} disabled={loading}>
// //                                 <i className="ri-filter-off-line me-1"></i> Clear
// //                             </Button>
// //                             <Button style={{ backgroundColor: THEME_COLOR, borderColor: THEME_COLOR }} size="sm" onClick={openCreateModal}>
// //                                 <i className="ri-add-line me-1"></i> New Booking
// //                             </Button>
// //                         </div>
// //                     </div>

// //                     {/* --- FILTERS --- */}
// //                     <div className="card-body border-top bg-light">
// //                         <div className="row g-3">
// //                             <div className="col-md-3">
// //                                 <label className="form-label small fw-bold text-muted">Appointment No</label>
// //                                 <input type="text" className="form-control form-control-sm" placeholder="Type..." value={filters.appointmentNo} onChange={e => setFilters({...filters, appointmentNo: e.target.value})} />
// //                             </div>
// //                             <div className="col-md-3">
// //                                 <label className="form-label small fw-bold text-muted">Filter by Salon</label>
// //                                 <Form.Select size="sm" value={filters.salonId} onChange={e => setFilters({...filters, salonId: e.target.value})}>
// //                                     <option value="all">All Salons</option>
// //                                     {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
// //                                 </Form.Select>
// //                             </div>
// //                             <div className="col-md-2">
// //                                 <label className="form-label small fw-bold text-muted">Status</label>
// //                                 <Form.Select size="sm" value={filters.status} onChange={e => setFilters({...filters, status: e.target.value})}>
// //                                     <option value="all">All Status</option>
// //                                     <option value="PENDING">Pending</option>
// //                                     <option value="Confirmed">Confirmed</option>
// //                                     <option value="Completed">Completed</option>
// //                                     <option value="Cancelled">Cancelled</option>
// //                                 </Form.Select>
// //                             </div>
// //                             <div className="col-md-2">
// //                                 <label className="form-label small fw-bold text-muted">Date</label>
// //                                 <input type="date" className="form-control form-control-sm" value={filters.date} onChange={e => setFilters({...filters, date: e.target.value})} />
// //                             </div>
// //                             <div className="col-md-2">
// //                                 <label className="form-label small fw-bold text-muted">Customer</label>
// //                                 <input type="text" className="form-control form-control-sm" placeholder="Name..." value={filters.searchTerm} onChange={e => setFilters({...filters, searchTerm: e.target.value})} />
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 {/* --- ALERTS --- */}
// //                 {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}
// //                 {success && <Alert variant="success" onClose={() => setSuccess('')} dismissible>{success}</Alert>}

// //                 {/* --- TABLE --- */}
// //                 <div className="card shadow-sm border-0 rounded-4 overflow-hidden mb-4">
// //                     {loading ? (
// //                         <div className="text-center py-5"><Spinner animation="border" style={{color: THEME_COLOR}} /></div>
// //                     ) : (
// //                         <div className="table-responsive">
// //                             <Table hover className="align-middle mb-0">
// //                                 <thead className="bg-light">
// //                                     <tr className="text-uppercase small text-secondary">
// //                                         <th className="ps-4">Appt No</th>
// //                                         <th>Salon</th>
// //                                         <th>Customer</th>
// //                                         <th>Service & Staff</th>
// //                                         <th>Date/Status</th>
// //                                         <th className="text-center">Actions</th>
// //                                     </tr>
// //                                 </thead>
// //                                 <tbody>
// //                                     {currentTableData.map(apt => (
// //                                         <tr key={apt.appointmentId}>
// //                                             <td className="ps-4"><div className="fw-bold text-primary">{apt.appointmentNo || 'N/A'}</div></td>
// //                                             <td><Badge bg="light" text="dark" className="border">{apt.salon?.name || 'Unknown'}</Badge></td>
// //                                             <td>
// //                                                 <div className="fw-bold small">{apt.user?.name || apt.customerName}</div>
// //                                                 <div className="text-muted" style={{fontSize: '11px'}}>{apt.user?.phoneNumber || apt.phoneNumber}</div>
// //                                             </td>
// //                                             <td>
// //                                                 <div className="fw-bold small">{apt.serviceType?.name}</div>
// //                                                 <div className="text-muted small"><i className="ri-user-line me-1"></i>{apt.staff?.name || 'Unassigned'}</div>
// //                                             </td>
// //                                             <td>
// //                                                 <div className="fw-bold small">{formatDateTime(apt.startTime)}</div>
// //                                                 <Badge bg={STATUS_COLORS[apt.status] || 'secondary'} className="mt-1">{apt.status}</Badge>
// //                                             </td>
// //                                             <td className="text-center">
// //                                                 <Button variant="link" size="sm" onClick={() => {setSelectedAppointment(apt); setShowDetailsModal(true);}}><i className="ri-eye-line text-primary fs-5"></i></Button>
// //                                                 <Button variant="link" size="sm" onClick={() => openEditModal(apt)}><i className="ri-pencil-line text-warning fs-5"></i></Button>
// //                                                 <Button variant="link" size="sm" onClick={() => {setAppointmentToCancel(apt); setShowCancelModal(true);}}><i className="ri-close-circle-line text-danger fs-5"></i></Button>
// //                                             </td>
// //                                         </tr>
// //                                     ))}
// //                                 </tbody>
// //                             </Table>
// //                         </div>
// //                     )}
// //                 </div>

// //                 {/* --- FORM MODAL (RE-ADDED STATUS & NOTES) --- */}
// //                 <Modal show={showFormModal} onHide={() => setShowFormModal(false)} size="lg" centered backdrop="static">
// //                     <Modal.Header closeButton><Modal.Title className="fw-bold">{isEditMode ? 'Edit Appointment' : 'New Appointment'}</Modal.Title></Modal.Header>
// //                     <Modal.Body>
// //                         <Form>
// //                             <div className="row g-3">
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Select Salon *</Form.Label>
// //                                     <Form.Select value={formData.salonId || ''} onChange={e => setFormData({...formData, salonId: e.target.value})} disabled={isEditMode}>
// //                                         <option value="">-- Choose --</option>
// //                                         {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
// //                                     </Form.Select>
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Customer Name *</Form.Label>
// //                                     <Form.Control type="text" value={formData.customerName} onChange={e => setFormData({...formData, customerName: e.target.value})} />
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Email *</Form.Label>
// //                                     <Form.Control type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Phone</Form.Label>
// //                                     <Form.Control type="text" value={formData.phoneNumber} onChange={e => setFormData({...formData, phoneNumber: e.target.value})} />
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Service *</Form.Label>
// //                                     <Form.Select value={formData.serviceTypeId} onChange={e => setFormData({...formData, serviceTypeId: e.target.value})}>
// //                                         <option value="">-- Choose --</option>
// //                                         {services.map(s => <option key={s.serviceTypeId} value={s.serviceTypeId}>{s.name}</option>)}
// //                                     </Form.Select>
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Staff</Form.Label>
// //                                     <Form.Select value={formData.staffId} onChange={e => setFormData({...formData, staffId: e.target.value})}>
// //                                         <option value="">-- Auto Assign --</option>
// //                                         {filteredStaff.map(s => <option key={s.staffId} value={s.staffId}>{s.name}</option>)}
// //                                     </Form.Select>
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Start Time *</Form.Label>
// //                                     <Form.Control type="datetime-local" value={formData.startTime} onChange={e => setFormData({...formData, startTime: e.target.value})} />
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">End Time</Form.Label>
// //                                     <Form.Control type="datetime-local" value={formData.endTime} onChange={e => setFormData({...formData, endTime: e.target.value})} />
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Status</Form.Label>
// //                                     <Form.Select value={formData.status} onChange={e => setFormData({...formData, status: e.target.value})}>
// //                                         <option value="PENDING">Pending</option>
// //                                         <option value="CONFIRMED">Confirmed</option>
// //                                         <option value="COMPLETED">Completed</option>
// //                                         <option value="CANCELLED">Cancelled</option>
// //                                     </Form.Select>
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <Form.Label className="small fw-bold">Notes</Form.Label>
// //                                     <Form.Control as="textarea" rows={1} value={formData.notes || ''} onChange={e => setFormData({...formData, notes: e.target.value})} />
// //                                 </div>
// //                             </div>
// //                         </Form>
// //                     </Modal.Body>
// //                     <Modal.Footer>
// //                         <Button variant="light" onClick={() => setShowFormModal(false)}>Cancel</Button>
// //                         <Button style={{backgroundColor: THEME_COLOR}} onClick={handleFormSubmit} disabled={btnLoading}>{btnLoading ? 'Saving...' : 'Save Appointment'}</Button>
// //                     </Modal.Footer>
// //                 </Modal>

// //                 {/* DETAILS MODAL */}
// //                 <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="lg" centered>
// //                     <Modal.Header closeButton><Modal.Title className="fw-bold">Appointment Details</Modal.Title></Modal.Header>
// //                     <Modal.Body>
// //                         {selectedAppointment && (
// //                             <div className="row g-4">
// //                                 <div className="col-md-6">
// //                                     <div className="p-3 bg-light rounded-3 h-100">
// //                                         <h6 className="fw-bold text-uppercase small mb-3">Customer & Salon</h6>
// //                                         <p><strong>Salon:</strong> {selectedAppointment.salon?.name}</p>
// //                                         <p><strong>Name:</strong> {selectedAppointment.user?.name || selectedAppointment.customerName}</p>
// //                                         <p><strong>Email:</strong> {selectedAppointment.user?.email || selectedAppointment.email}</p>
// //                                     </div>
// //                                 </div>
// //                                 <div className="col-md-6">
// //                                     <div className="p-3 bg-light rounded-3 h-100">
// //                                         <h6 className="fw-bold text-uppercase small mb-3">Time & Service</h6>
// //                                         <p><strong>Service:</strong> {selectedAppointment.serviceType?.name}</p>
// //                                         <p><strong>Status:</strong> <Badge bg={STATUS_COLORS[selectedAppointment.status] || 'secondary'}>{selectedAppointment.status}</Badge></p>
// //                                         <p><strong>Start:</strong> {formatDateTime(selectedAppointment.startTime)}</p>
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         )}
// //                     </Modal.Body>
// //                 </Modal>
                
// //                 {/* CANCEL MODAL */}
// //                 <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered size="sm">
// //                     <Modal.Body className="text-center p-4">
// //                         <h5 className="fw-bold text-danger">Cancel?</h5>
// //                         <p className="small text-muted">Cancel appointment {appointmentToCancel?.appointmentNo}?</p>
// //                         <div className="d-grid gap-2">
// //                             <Button variant="danger" onClick={handleCancel} disabled={btnLoading}>Yes, Cancel</Button>
// //                             <Button variant="light" onClick={() => setShowCancelModal(false)}>No</Button>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //             </div>
// //         </div>
// //     );
// // };

// // export default Appointments;

// // web view








import React, { useState, useEffect } from 'react';
import { Modal, Button, Badge, Form, Alert, Spinner, Table } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const Appointments = () => {
    const [allAppointments, setAllAppointments] = useState([]); 
    const [filteredAppointments, setFilteredAppointments] = useState([]); 
    const [salons, setSalons] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [services, setServices] = useState([]);
    
    const [loading, setLoading] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); 

    const [filters, setFilters] = useState({
        searchTerm: '',
        appointmentNo: '',
        status: 'all',
        salonId: 'all',
        date: ''
    });

    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [appointmentToCancel, setAppointmentToCancel] = useState(null);

    const [showFormModal, setShowFormModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    
    const initialFormState = {
        appointmentId: null,
        salonId: '',
        customerName: '',
        email: '',
        phoneNumber: '',
        serviceTypeId: '',
        staffId: '',
        startTime: '',
        endTime: '',
        status: 'PENDING',
        notes: ''
    };
    const [formData, setFormData] = useState(initialFormState);
    const [filteredStaff, setFilteredStaff] = useState([]); 

    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';
    const STATUS_COLORS = {
        'Scheduled': 'primary', 'Confirmed': 'success', 'CONFIRMED': 'success',
        'Completed': 'secondary', 'COMPLETED': 'secondary', 'Cancelled': 'danger',
        'CANCELLED': 'danger', 'Pending': 'warning', 'PENDING': 'warning', 'Noshow': 'dark'
    };

    useEffect(() => {
        fetchDropdowns();
        fetchAppointments();
    }, []);

    useEffect(() => {
        applyFilters();
        setCurrentPage(1);
    }, [filters, allAppointments]);

    const fetchDropdowns = async () => {
        try {
            const [salonRes, staffRes, serviceRes] = await Promise.all([
                axios.get(`${config.APIACTIVEURL}${config.GETALLSALON}`),
                axios.get(`${config.APIACTIVEURL}${config.GETALLSTAFF}`),
                axios.get(`${config.APIACTIVEURL}${config.GETSERVICETYPE}`)
            ]);
            setSalons(salonRes.data.data || salonRes.data || []);
            setStaffList(staffRes.data.data || staffRes.data || []);
            setServices(serviceRes.data.data || serviceRes.data || []);
        } catch (err) {
            console.error("Error loading dropdowns", err);
        }
    };

    const fetchAppointments = async () => {
        try {
            setLoading(true);
            setError('');
            const res = await axios.get(`${config.APIACTIVEURL}${config.GETALLAPPOINTMENTS}`, {
                params: { pageSize: 1000, pageNumber: 1 } 
            });
            
            let data = [];
            if (res.data.data && Array.isArray(res.data.data)) { data = res.data.data; }
            else if (Array.isArray(res.data)) { data = res.data; }
            else if (res.data.items) { data = res.data.items; }

            setAllAppointments(data);
            setFilteredAppointments(data); 
        } catch (error) {
            setError('Failed to load appointments.');
        } finally {
            setLoading(false);
        }
    };

    const applyFilters = () => {
        let result = [...allAppointments];

        if (filters.appointmentNo) {
            const term = filters.appointmentNo.toLowerCase();
            result = result.filter(item => (item.appointmentNo || '').toLowerCase().includes(term));
        }
        if (filters.salonId !== 'all') {
            result = result.filter(item => item.salonId === filters.salonId);
        }
        if (filters.status !== 'all') {
            result = result.filter(item => (item.status || '').toUpperCase() === filters.status.toUpperCase());
        }
        if (filters.date) {
            result = result.filter(item => item.startTime && item.startTime.startsWith(filters.date));
        }
        if (filters.searchTerm) {
            const term = filters.searchTerm.toLowerCase();
            result = result.filter(item => 
                (item.user?.name || item.customerName || '').toLowerCase().includes(term) ||
                (item.user?.email || item.email || '').toLowerCase().includes(term) ||
                (item.user?.phoneNumber || item.phoneNumber || '').toLowerCase().includes(term)
            );
        }
        setFilteredAppointments(result);
    };

    const clearFilters = () => {
        setFilters({ searchTerm: '', appointmentNo: '', status: 'all', salonId: 'all', date: '' });
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentTableData = filteredAppointments.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage);

    useEffect(() => {
        if (formData.salonId) {
            const salonStaff = staffList.filter(s => s.salonId === formData.salonId);
            setFilteredStaff(salonStaff);
        } else {
            setFilteredStaff([]);
        }
    }, [formData.salonId, staffList]);

    const handleFormSubmit = async () => {
        if (!formData.customerName || !formData.email || !formData.salonId || !formData.startTime || !formData.serviceTypeId) {
            setError("Please fill in all required fields.");
            return;
        }

        setBtnLoading(true);
        setError('');
        
        try {
            const payload = {
                appointmentId: isEditMode ? formData.appointmentId : "00000000-0000-0000-0000-000000000000",
                salonId: formData.salonId,
                serviceTypeId: formData.serviceTypeId,
                staffId: formData.staffId || "00000000-0000-0000-0000-000000000000",
                customerName: formData.customerName,
                email: formData.email,
                phoneNumber: formData.phoneNumber || "",
                startTime: formData.startTime,
                endTime: formData.endTime || formData.startTime, 
                status: formData.status || "PENDING",
                notes: formData.notes || ""
            };

            const baseUrl = `${config.APIACTIVEURL}${config.APPOINTMENTS}`; 

            if (isEditMode) {
                await axios.put(`${baseUrl}/${payload.appointmentId}`, payload);
                setSuccess('Appointment updated successfully!');
            } else {
                await axios.post(baseUrl, payload);
                setSuccess('Appointment created successfully!');
            }

            setShowFormModal(false);
            fetchAppointments(); 
            setTimeout(() => setSuccess(''), 3000);
        } catch (err) {
            setError(err.response?.data?.message || 'Operation failed.');
        } finally {
            setBtnLoading(false);
        }
    };

    const openCreateModal = () => {
        setFormData(initialFormState);
        setIsEditMode(false);
        setShowFormModal(true);
    };

    const openEditModal = (apt) => {
        setFormData({
            appointmentId: apt.appointmentId,
            salonId: apt.salonId || '',
            customerName: apt.user?.name || apt.customerName || '',
            email: apt.user?.email || apt.email || '',
            phoneNumber: apt.user?.phoneNumber || apt.phoneNumber || '',
            serviceTypeId: apt.serviceTypeId || '',
            staffId: (apt.staffId === "00000000-0000-0000-0000-000000000000" || !apt.staffId) ? '' : apt.staffId,
            startTime: apt.startTime ? apt.startTime.slice(0, 16) : '',
            endTime: apt.endTime ? apt.endTime.slice(0, 16) : '',
            status: apt.status || 'PENDING',
            notes: apt.notes || ''
        });
        setIsEditMode(true);
        setShowFormModal(true);
    };

    const handleCancel = async () => {
        if (!appointmentToCancel) return;
        setBtnLoading(true);
        try {
            if (appointmentToCancel.appointmentNo) {
                await axios.post(`${config.APIACTIVEURL}${config.CANCELAPPPOINTMENT}/${appointmentToCancel.appointmentNo}`);
            } else {
                 await axios.delete(`${config.APIACTIVEURL}${config.APPOINTMENTS}/${appointmentToCancel.appointmentId}`);
            }
            fetchAppointments();
            setSuccess('Appointment cancelled.');
            setShowCancelModal(false);
            setTimeout(() => setSuccess(''), 3000);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to cancel.');
        } finally {
            setBtnLoading(false);
        }
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        const cleanDate = dateString.replace('Z', '').split('.')[0];
        const d = new Date(cleanDate); 
        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="page-content" style={{ paddingTop: "90px", minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            <div className="container-fluid px-lg-4">
                
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                    <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <h4 className="fw-bold mb-0" style={{ color: THEME_COLOR }}>
                            <i className="ri-admin-line me-2"></i>
                            Appointments (Admin)
                        </h4>
                        <div className="d-flex gap-2">
                            <Button variant="danger" size="sm" onClick={clearFilters} disabled={loading}>
                                <i className="ri-filter-off-line me-1"></i> Clear
                            </Button>
                            <Button style={{ backgroundColor: THEME_COLOR, borderColor: THEME_COLOR }} size="sm" onClick={openCreateModal}>
                                <i className="ri-add-line me-1"></i> New Booking
                            </Button>
                        </div>
                    </div>

                    <div className="card-body border-top bg-light">
                        <div className="row g-3">
                            <div className="col-md-3 col-6">
                                <label className="form-label small fw-bold text-muted">Appointment No</label>
                                <input type="text" className="form-control form-control-sm" placeholder="Type..." value={filters.appointmentNo} onChange={e => setFilters({...filters, appointmentNo: e.target.value})} />
                            </div>
                            <div className="col-md-3 col-6">
                                <label className="form-label small fw-bold text-muted">Filter by Salon</label>
                                <Form.Select size="sm" value={filters.salonId} onChange={e => setFilters({...filters, salonId: e.target.value})}>
                                    <option value="all">All Salons</option>
                                    {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
                                </Form.Select>
                            </div>
                            <div className="col-md-2 col-6">
                                <label className="form-label small fw-bold text-muted">Status</label>
                                <Form.Select size="sm" value={filters.status} onChange={e => setFilters({...filters, status: e.target.value})}>
                                    <option value="all">All Status</option>
                                    <option value="PENDING">Pending</option>
                                    <option value="Confirmed">Confirmed</option>
                                    <option value="Completed">Completed</option>
                                    <option value="Cancelled">Cancelled</option>
                                </Form.Select>
                            </div>
                            <div className="col-md-2 col-6">
                                <label className="form-label small fw-bold text-muted">Date</label>
                                <input type="date" className="form-control form-control-sm" value={filters.date} onChange={e => setFilters({...filters, date: e.target.value})} />
                            </div>
                            <div className="col-md-2 col-12">
                                <label className="form-label small fw-bold text-muted">Customer</label>
                                <input type="text" className="form-control form-control-sm" placeholder="Name..." value={filters.searchTerm} onChange={e => setFilters({...filters, searchTerm: e.target.value})} />
                            </div>
                        </div>
                    </div>
                </div>

                {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}
                {success && <Alert variant="success" onClose={() => setSuccess('')} dismissible>{success}</Alert>}

                <div className="mb-4">
                    {loading ? (
                        <div className="text-center py-5 card shadow-sm border-0 rounded-4"><Spinner animation="border" style={{color: THEME_COLOR}} /></div>
                    ) : (
                        <>
                            {/* --- DESKTOP TABLE VIEW --- */}
                            <div className="d-none d-md-block card shadow-sm border-0 rounded-4 overflow-hidden">
                                <div className="table-responsive">
                                    <Table hover className="align-middle mb-0">
                                        <thead className="bg-light">
                                            <tr className="text-uppercase small text-secondary">
                                                <th className="ps-4">Appt No</th>
                                                <th>Salon</th>
                                                <th>Customer</th>
                                                <th>Service & Staff</th>
                                                <th>Date/Status</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData.map(apt => (
                                                <tr key={apt.appointmentId}>
                                                    <td className="ps-4"><div className="fw-bold text-primary">{apt.appointmentNo || 'N/A'}</div></td>
                                                    <td><Badge bg="light" text="dark" className="border">{apt.salon?.name || 'Unknown'}</Badge></td>
                                                    <td>
                                                        <div className="fw-bold small">{apt.user?.name || apt.customerName}</div>
                                                        <div className="text-muted" style={{fontSize: '11px'}}>{apt.user?.phoneNumber || apt.phoneNumber}</div>
                                                    </td>
                                                    <td>
                                                        <div className="fw-bold small">{apt.serviceType?.name}</div>
                                                        <div className="text-muted small"><i className="ri-user-line me-1"></i>{apt.staff?.name || 'Unassigned'}</div>
                                                    </td>
                                                    <td>
                                                        <div className="fw-bold small">{formatDateTime(apt.startTime)}</div>
                                                        <Badge bg={STATUS_COLORS[apt.status] || 'secondary'} className="mt-1">{apt.status}</Badge>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button variant="link" size="sm" onClick={() => {setSelectedAppointment(apt); setShowDetailsModal(true);}}><i className="ri-eye-line text-primary fs-5"></i></Button>
                                                        <Button variant="link" size="sm" onClick={() => openEditModal(apt)}><i className="ri-pencil-line text-warning fs-5"></i></Button>
                                                        <Button variant="link" size="sm" onClick={() => {setAppointmentToCancel(apt); setShowCancelModal(true);}}><i className="ri-close-circle-line text-danger fs-5"></i></Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>

                            {/* --- MOBILE CARD VIEW --- */}
                            <div className="d-md-none">
                                {currentTableData.map(apt => (
                                    <div key={apt.appointmentId} className="card shadow-sm border-0 rounded-4 mb-3">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <span className="fw-bold text-primary">#{apt.appointmentNo || 'N/A'}</span>
                                                    <div className="small text-muted">{apt.salon?.name}</div>
                                                </div>
                                                <Badge bg={STATUS_COLORS[apt.status] || 'secondary'}>{apt.status}</Badge>
                                            </div>
                                            <hr className="my-2 opacity-25" />
                                            <div className="row g-2 mb-3">
                                                <div className="col-6">
                                                    <label className="text-muted small d-block">Customer</label>
                                                    <span className="small fw-bold">{apt.user?.name || apt.customerName}</span>
                                                </div>
                                                <div className="col-6 text-end">
                                                    <label className="text-muted small d-block">Service</label>
                                                    <span className="small fw-bold">{apt.serviceType?.name}</span>
                                                </div>
                                                <div className="col-6">
                                                    <label className="text-muted small d-block">Date & Time</label>
                                                    <span className="small fw-bold">{formatDateTime(apt.startTime)}</span>
                                                </div>
                                                <div className="col-6 text-end">
                                                    <label className="text-muted small d-block">Staff</label>
                                                    <span className="small fw-bold">{apt.staff?.name || 'Unassigned'}</span>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-around border-top pt-2">
                                                <Button variant="link" className="text-decoration-none" onClick={() => {setSelectedAppointment(apt); setShowDetailsModal(true);}}>
                                                    <i className="ri-eye-line me-1"></i> View
                                                </Button>
                                                <Button variant="link" className="text-decoration-none text-warning" onClick={() => openEditModal(apt)}>
                                                    <i className="ri-pencil-line me-1"></i> Edit
                                                </Button>
                                                <Button variant="link" className="text-decoration-none text-danger" onClick={() => {setAppointmentToCancel(apt); setShowCancelModal(true);}}>
                                                    <i className="ri-close-circle-line me-1"></i> Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                <Modal show={showFormModal} onHide={() => setShowFormModal(false)} size="lg" centered backdrop="static">
                    <Modal.Header closeButton><Modal.Title className="fw-bold">{isEditMode ? 'Edit Appointment' : 'New Appointment'}</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Select Salon *</Form.Label>
                                    <Form.Select value={formData.salonId || ''} onChange={e => setFormData({...formData, salonId: e.target.value})} disabled={isEditMode}>
                                        <option value="">-- Choose --</option>
                                        {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
                                    </Form.Select>
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Customer Name *</Form.Label>
                                    <Form.Control type="text" value={formData.customerName} onChange={e => setFormData({...formData, customerName: e.target.value})} />
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Email *</Form.Label>
                                    <Form.Control type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Phone</Form.Label>
                                    <Form.Control type="text" value={formData.phoneNumber} onChange={e => setFormData({...formData, phoneNumber: e.target.value})} />
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Service *</Form.Label>
                                    <Form.Select value={formData.serviceTypeId} onChange={e => setFormData({...formData, serviceTypeId: e.target.value})}>
                                        <option value="">-- Choose --</option>
                                        {services.map(s => <option key={s.serviceTypeId} value={s.serviceTypeId}>{s.name}</option>)}
                                    </Form.Select>
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Staff</Form.Label>
                                    <Form.Select value={formData.staffId} onChange={e => setFormData({...formData, staffId: e.target.value})}>
                                        <option value="">-- Auto Assign --</option>
                                        {filteredStaff.map(s => <option key={s.staffId} value={s.staffId}>{s.name}</option>)}
                                    </Form.Select>
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Start Time *</Form.Label>
                                    <Form.Control type="datetime-local" value={formData.startTime} onChange={e => setFormData({...formData, startTime: e.target.value})} />
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">End Time</Form.Label>
                                    <Form.Control type="datetime-local" value={formData.endTime} onChange={e => setFormData({...formData, endTime: e.target.value})} />
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Status</Form.Label>
                                    <Form.Select value={formData.status} onChange={e => setFormData({...formData, status: e.target.value})}>
                                        <option value="PENDING">Pending</option>
                                        <option value="CONFIRMED">Confirmed</option>
                                        <option value="COMPLETED">Completed</option>
                                        <option value="CANCELLED">Cancelled</option>
                                    </Form.Select>
                                </div>
                                <div className="col-md-6">
                                    <Form.Label className="small fw-bold">Notes</Form.Label>
                                    <Form.Control as="textarea" rows={1} value={formData.notes || ''} onChange={e => setFormData({...formData, notes: e.target.value})} />
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={() => setShowFormModal(false)}>Cancel</Button>
                        <Button style={{backgroundColor: THEME_COLOR}} onClick={handleFormSubmit} disabled={btnLoading}>{btnLoading ? 'Saving...' : 'Save Appointment'}</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="lg" centered>
                    <Modal.Header closeButton><Modal.Title className="fw-bold">Appointment Details</Modal.Title></Modal.Header>
                    <Modal.Body>
                        {selectedAppointment && (
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded-3 h-100">
                                        <h6 className="fw-bold text-uppercase small mb-3">Customer & Salon</h6>
                                        <p><strong>Salon:</strong> {selectedAppointment.salon?.name}</p>
                                        <p><strong>Name:</strong> {selectedAppointment.user?.name || selectedAppointment.customerName}</p>
                                        <p><strong>Email:</strong> {selectedAppointment.user?.email || selectedAppointment.email}</p>
                                        <p><strong>Phone:</strong> {selectedAppointment.user?.phoneNumber || selectedAppointment.phoneNumber}</p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded-3 h-100">
                                        <h6 className="fw-bold text-uppercase small mb-3">Time & Service</h6>
                                        <p><strong>Service:</strong> {selectedAppointment.serviceType?.name}</p>
                                        <p><strong>Staff:</strong> {selectedAppointment.staff?.name || 'Unassigned'}</p>
                                        <p><strong>Status:</strong> <Badge bg={STATUS_COLORS[selectedAppointment.status] || 'secondary'}>{selectedAppointment.status}</Badge></p>
                                        <p><strong>Start:</strong> {formatDateTime(selectedAppointment.startTime)}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
                
                <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered size="sm">
                    <Modal.Body className="text-center p-4">
                        <h5 className="fw-bold text-danger">Cancel?</h5>
                        <p className="small text-muted">Cancel appointment {appointmentToCancel?.appointmentNo}?</p>
                        <div className="d-grid gap-2">
                            <Button variant="danger" onClick={handleCancel} disabled={btnLoading}>Yes, Cancel</Button>
                            <Button variant="light" onClick={() => setShowCancelModal(false)}>No</Button>
                        </div>
                    </Modal.Body>
                </Modal>

            </div>
        </div>
    );
};

export default Appointments;